export const FETCH_PM_IWO_LIST_REQUEST = "FETCH_PM_IWO_LIST_REQUEST";
export const FETCH_PM_IWO_LIST_SUCCESS = "FETCH_PM_IWO_LIST_SUCCESS";
export const FETCH_PM_IWO_LIST_FAILURE = "FETCH_PM_IWO_LIST_FAILURE";

export const INSERT_PM_FRAME_REQUEST = "INSERT_PM_FRAME_REQUEST";
export const INSERT_PM_FRAME_SUCCESS = "INSERT_PM_FRAME_SUCCESS";
export const INSERT_PM_FRAME_FAILURE = "INSERT_PM_FRAME_FAILURE";

export const FETCH_PM_FRAME_LIST_REQUEST = "FETCH_PM_FRAME_LIST_REQUEST";
export const FETCH_PM_FRAME_LIST_SUCCESS = "FETCH_PM_FRAME_LIST_SUCCESS";
export const FETCH_PM_FRAME_LIST_FAILURE = "FETCH_PM_FRAME_LIST_FAILURE";

export const INSERT_PM_DAILY_REMARK_REQUEST = "INSERT_PM_DAILY_REMARK_REQUEST";
export const INSERT_PM_DAILY_REMARK_SUCCESS = "INSERT_PM_DAILY_REMARK_SUCCESS";
export const INSERT_PM_DAILY_REMARK_FAILURE = "INSERT_PM_DAILY_REMARK_FAILURE";

export const UPDATE_PM_COMPLETION_REQUEST = "UPDATE_PM_COMPLETION_REQUEST";
export const UPDATE_PM_COMPLETION_SUCCESS = "UPDATE_PM_COMPLETION_SUCCESS";
export const UPDATE_PM_COMPLETION_FAILURE = "UPDATE_PM_COMPLETION_FAILURE";

export const UPDATE_PM_FRAME_REQUEST = "UPDATE_PM_FRAME_REQUEST";
export const UPDATE_PM_FRAME_SUCCESS = "UPDATE_PM_FRAME_SUCCESS";
export const UPDATE_PM_FRAME_FAILURE = "UPDATE_PM_FRAME_FAILURE";

export const FETCH_PM_DELAY_REASONS_REQUEST = "FETCH_PM_DELAY_REASONS_REQUEST";
export const FETCH_PM_DELAY_REASONS_SUCCESS = "FETCH_PM_DELAY_REASONS_SUCCESS";
export const FETCH_PM_DELAY_REASONS_FAILURE = "FETCH_PM_DELAY_REASONS_FAILURE";

export const DELETE_PM_FRAME_REQUEST = "DELETE_PM_FRAME_REQUEST";
export const DELETE_PM_FRAME_SUCCESS = "DELETE_PM_FRAME_SUCCESS";
export const DELETE_PM_FRAME_FAILURE = "DELETE_PM_FRAME_FAILURE";

export const FETCH_PM_IWO_FRAMES_REQUEST = "FETCH_PM_IWO_FRAMES_REQUEST";
export const FETCH_PM_IWO_FRAMES_SUCCESS = "FETCH_PM_IWO_FRAMES_SUCCESS";
export const FETCH_PM_IWO_FRAMES_FAILURE = "FETCH_PM_IWO_FRAMES_FAILURE";